





























































































import Vue from 'vue';
import { required, minLength } from 'vuelidate/lib/validators';
import { IAddress } from '@/common/interfaces/shared.interface';
import CustomButton from '@/components/layout/buttons/CustomButton.vue';
import { EInputIdentifier } from '@/common/enums/input-identifier.enum';
import CountrySelectInput from '../inputs/CountrySelectInput.vue';
import TextInput from '../inputs/TextInput.vue';

const defaultAddress: Partial<IAddress> = {
  city: ``,
  countryISO: ``,
  extra: ``,
  recipient: ``,
  street: ``,
  streetNumber: ``,
  zipCode: ``,
};

interface IAddressFormComponent {
  EInputIdentifier: typeof EInputIdentifier;
  internalCopy: Partial<IAddress>;
}

export default Vue.extend({
  components: {
    CountrySelectInput,
    CustomButton,
    TextInput,
  },
  data(): IAddressFormComponent {
    return {
      EInputIdentifier,
      internalCopy: { ...defaultAddress },
    };
  },
  props: {
    address: {
      default: null,
      type: Object as () => IAddress | null,
    },
    buttonControl: {
      default: () => {},
      type: Object as () => Record<string, string>,
    },
    instantUpdate: {
      default: false,
      type: Boolean,
    },
    isCheckoutForm: {
      default: false,
      type: Boolean,
    },
    showEmptyOption: {
      default: false,
      type: Boolean,
    },
    showRecipient: {
      default: true,
      type: Boolean,
    },
  },
  methods: {
    abort(): void {
      this.resetInternalCopy();
      this.$emit(`abort`);
    },
    onInput(): void {
      if(this.instantUpdate) {
        this.$emit(`change`, { ...this.internalCopy });
        this.$emit(`validate`, !this.$v.$anyError);
      }
    },
    resetInternalCopy(): void {
      if(this.address) {
        this.internalCopy = { ...this.address };
      } else {
        this.internalCopy = { ...defaultAddress };
      }
    },
    resetValidations(): void {
      this.$v.$reset();
    },
    save(): void {
      this.$emit(`change`, { ...this.internalCopy });
      this.$emit(`validate`, !this.$v.$anyError);
    },
    validate(): void {
      this.$v.$touch();
      this.$emit(`validate`, !this.$v.$anyError);
    },
  },
  // vuelidate types don't seem to work as advertised, therefore any.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validations(): any {
    /*
     * sadly we need this code duplication
     * vuelidate seems to not be able to work the right way if we just say
     * recipient: { required: this.showRecipient }
     * required is an Object instead of true or false if we use the line above
     * therefore the validation doesn't work
     */
    if(this.showRecipient) {
      return {
        internalCopy: {
          city: {
            minLength: minLength(1),
            required,
          },
          countryISO: {
            required,
          },
          extra: {},
          recipient: {
            required,
          },
          street: {
            minLength: minLength(1),
            required,
          },
          streetNumber: {
            required,
          },
          zipCode: {
            required,
          },
        },
      };
    }
    return {
      internalCopy: {
        city: {
          minLength: minLength(1),
          required,
        },
        countryISO: {
          required,
        },
        extra: {},
        recipient: {},
        street: {
          minLength: minLength(1),
          required,
        },
        streetNumber: {
          required,
        },
        zipCode: {
          required,
        },
      },
    };
  },
  watch: {
    address: {
      deep: true,
      handler(value) {
        if(value != null) {
          this.internalCopy = { ...value };
        } else {
          this.internalCopy = { ...defaultAddress };
        }
      },
      immediate: true,
    },
  },
});
